module.exports = __webpack_public_path__ + "img/renwu_tu.95106885.png";